import CustomDrawer from "@/components/drawer";
import Header from "@/components/header";
import { Gender } from "@/models/club";
import { CustomLink } from "@/styles/shared/link/link.style";
import {
  ActionIcon,
  Avatar,
  Badge,
  Button,
  Card,
  Container,
  Group,
  Menu,
  Modal,
  Skeleton,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconCake,
  IconCalendar,
  IconChevronLeft,
  IconDiscount,
  IconDotsVertical,
  IconGenderBigender,
  IconPhone,
  IconUserPlus,
} from "@tabler/icons-react";
import moment from "moment-jalaali";
import { useNavigate, useParams } from "react-router-dom";
import UseGetCustomerById from "../hooks/useGetCustomerById";
import useRemoveCustomer from "@/services/customer/hooks/useRemoveCustomer";
import useIsSmall from "@/hooks/useIsSmall";

function CustomerDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isSmall = useIsSmall();
  const { data: user, isLoading } = UseGetCustomerById({ id: Number(id) });
  const { mutate: removeCustomer, isLoading: isRemoving } = useRemoveCustomer();

  const [opened, { open, close }] = useDisclosure(false);
  const [openedDelete, { open: openDelete, close: closeDelete }] =
    useDisclosure(false);

  const handleDelete = () => {
    removeCustomer(Number(id), {
      onSuccess: () => {
        closeDelete();
        navigate("/dashboard/customers");
      },
    });
  };

  return (
    <>
      <Header
        title=""
        showBack
        route="/dashboard/customers"
        customComponentHide
        customComponent={
          <>
            <Group>
              <Avatar variant="outline" color="blue" size="md" p="3">
                {user?.firstName?.charAt(0) || ""}
              </Avatar>
              <Text>
                {user?.firstName} {user?.lastName}
              </Text>
            </Group>
          </>
        }
      />
      <Container w="100%" size="md" bg="white">
        <Stack>
          <Stack justify="center" align="center" gap="0">
            <Avatar size={100} mb="md">
              {user?.firstName?.charAt(0) || ""}
            </Avatar>
            <Title order={4} pb="0">
              {isLoading ? (
                <Skeleton w="150px" height={20} />
              ) : (
                <>
                  {user?.firstName} {user?.lastName}
                </>
              )}
            </Title>
            <Text c="dimmed">
              {isLoading ? (
                <Skeleton w="100px" height={20} />
              ) : (
                <>{user?.phoneNumber}</>
              )}
            </Text>
          </Stack>
          <Text size="sm" style={{ overflowWrap: "anywhere" }}>معرف: {user?.referrer || "—"}</Text>
          <Group gap="xs">
            <Button
              variant="filled"

              radius="xl"
              flex={8 / 10}
              disabled={isLoading}
              onClick={() => navigate(`/dashboard/calendar/${id}`)}
            >
              رزرو نوبت
            </Button>
            <Button
              variant="default"
              component="a"
              radius="xl"
              href={`tel:${user?.phoneNumber}`}
              leftSection={<IconPhone />}
              flex={8 / 10}
              disabled={isLoading}
            >
              تماس
            </Button>
            {isSmall ? (
              <ActionIcon
                variant="default"
                w={80}
                size="lg"

                radius="xl"
                flex={1 / 10}
                p="2"
                onClick={open}
                disabled={isLoading}
              >
                <IconDotsVertical stroke={1.5} />
              </ActionIcon>
            ) : (
              <Menu>
                <Menu.Target>
                  <ActionIcon
                    variant="default"
                    w={80}
                    size="lg"

                    radius="xl"
                    flex={1 / 10}
                    p="2"
                    disabled={isLoading}
                  >
                    <IconDotsVertical stroke={1.5} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <CustomLink to={`/dashboard/customers/edit/${id}`}>
                    <Menu.Item>
                      <Text> ویرایش اطلاعات</Text>
                    </Menu.Item>
                  </CustomLink>
                  <Menu.Item>
                    <Text c="red" onClick={openDelete}>
                      {" "}
                      حذف مخاطب
                    </Text>
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            )}
          </Group>
          <Card withBorder mt="xl">
            <Menu>
              <Menu.Item
                leftSection={
                  <IconGenderBigender
                    color={
                      user?.gender == null
                        ? "var(--mantine-color-dimmed)"
                        : "black"
                    }
                    size={20}
                    stroke={1.5}
                  />
                }
              >
                {isLoading ? (
                  <Skeleton w="100px" height={20} />
                ) : (
                  <>
                    {user?.gender !== null ? (
                      <Group justify="space-between">
                        <Text fw={500}>
                          {user?.gender === Gender.Value0 ? "آقا" : "خانم"}{" "}
                        </Text>
                        <Text size="xs" fw="lighter" c="dimmed">
                          جنسیت
                        </Text>
                      </Group>
                    ) : (
                      <Text
                        size="sm"
                        fw={500}
                        c="dimmed"
                        onClick={() =>
                          navigate(`/dashboard/customers/edit/${id}`)
                        }
                      >
                        افزودن جنسیت
                      </Text>
                    )}
                  </>
                )}
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconCake
                    color={
                      user?.birthDate == null
                        ? "var(--mantine-color-dimmed)"
                        : "black"
                    }
                    size={20}
                    stroke={1.5}
                  />
                }
              >
                {isLoading ? (
                  <Skeleton w="100px" height={20} />
                ) : (
                  <>
                    {user?.birthDate ? (
                      <Group justify="space-between">
                        <Text fw={500}>
                          {moment(user?.birthDate).format("jD jMMMM  ,jYYYY")}{" "}
                        </Text>
                        <Text size="xs" fw="lighter" c="dimmed">
                          تاریخ تولد
                        </Text>
                      </Group>
                    ) : (
                      <Text
                        size="sm"
                        fw={500}
                        c="dimmed"
                        onClick={() =>
                          navigate(`/dashboard/customers/edit/${id}`)
                        }
                      >
                        افزودن تاریخ تولد
                      </Text>
                    )}
                  </>
                )}
              </Menu.Item>
              <Menu.Item leftSection={<IconUserPlus size={20} stroke={1.5} />}>
                {isLoading ? (
                  <Skeleton w="100px" height={20} />
                ) : (
                  <Group justify="space-between">
                    <Text fw={500}>
                      {moment(user?.creationTime).format("jD jMMMM  ,jYYYY")}{" "}
                    </Text>
                    <Text size="xs" fw="lighter" c="dimmed">
                      تاریخ عضویت
                    </Text>
                  </Group>
                )}
              </Menu.Item>

              {/* <CustomLink to="/dashboard/messages">
                <Menu.Item
                  mt="xs"
                  leftSection={<IconHistoryToggle size={20} stroke={1.5} />}
                  rightSection={<IconChevronLeft size={20} stroke={1} />}
                >
                  <Text fw={500}> تاریخچه پیام ها </Text>
                </Menu.Item>
              </CustomLink> */}
            </Menu>
          </Card>

          <Card withBorder>
            <Menu>
              <Menu.Item
                leftSection={<IconCalendar size={20} stroke={1.5} />}
                rightSection={<IconChevronLeft size={20} stroke={1} />}
                disabled
              >
                <Group gap="5">
                  <Text fw={500}>نوبت ها</Text>
                  <Badge variant="light" >
                    <Text size="xs" c="dimmed">
                      {0}
                    </Text>
                  </Badge>
                </Group>
              </Menu.Item>
              <Menu.Item
                leftSection={<IconDiscount size={20} stroke={1.5} />}
                rightSection={<IconChevronLeft size={20} stroke={1} />}
                disabled
              >
                <Group gap="5">
                  <Text fw={500}> تخفیف ها</Text>
                  <Badge variant="light" >
                    <Text size="xs" c="dimmed">
                      0
                    </Text>
                  </Badge>
                </Group>
              </Menu.Item>
            </Menu>
          </Card>
        </Stack>
      </Container>

      <CustomDrawer
        opened={opened && isSmall}
        onClose={close}
        close={close}
        radius="md"
        custom="customer-actions"
        position="bottom"
        size="200"
      >
        <Menu>
          <CustomLink to={`/dashboard/customers/edit/${id}`}>
            <Menu.Item>
              <Text fw={500}> ویرایش اطلاعات</Text>
            </Menu.Item>
          </CustomLink>
          <Menu.Item>
            <Text fw={500} c="red" onClick={openDelete}>
              {" "}
              حذف مخاطب
            </Text>
          </Menu.Item>
        </Menu>
      </CustomDrawer>

      <Modal opened={openedDelete} onClose={closeDelete} title="حذف مخاطب">
        <Stack>
          <Title order={4}>آیا از حذف مخاطب اطمینان دارید؟</Title>
          <Group gap="xs">
            <Button color="red" onClick={handleDelete} loading={isRemoving}>
              بلی
            </Button>
            <Button
              variant="outline"
              onClick={closeDelete}
              loading={isRemoving}
            >
              انصراف
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}

export default CustomerDetails;
